module.exports = __webpack_public_path__ + "static/media/Rectangle103.41b51e59.svg";